import { render } from "./StoreCollectionItems.vue?vue&type=template&id=26f20adb&scoped=true"
import script from "./StoreCollectionItems.vue?vue&type=script&lang=js"
export * from "./StoreCollectionItems.vue?vue&type=script&lang=js"

import "./StoreCollectionItems.vue?vue&type=style&index=0&id=26f20adb&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f20adb"]])

export default __exports__